<template>
  <div v-show="showTabNumber == 100">

    <!-- 목록 시작 -->
    <md-card>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          <div>
            <select v-model="pagination.perPage" name="pages" @change="perPageChange">
              <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <grid ref="presidencySchaGrid"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @response="response"
        ></grid>

      </md-card-content>

      <slot name="bottomRightArea"></slot>
    </md-card>
  </div>
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  name: "presidencySchaListComp",

  props: {
    showTabNumber : {
      type: Number,
      default: 1
    }
  },

  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      presidencyCd : null,
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
    };
  },
  methods: {
    sendQuery (presidencyCd){
      this.presidencyCd = presidencyCd ? presidencyCd : this.presidencyCd;
      let params = {
        "presidencyCd" : this.presidencyCd
      };
      this.$refs.presidencySchaGrid.invoke("readData", 1, params);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_PRESIDENCY_SCHA_LIST, false, this.pagination, ['rowNum','checkbox']);
      this.gridProps['el'] = this.$refs.presidencySchaGrid;
      this.gridProps['columns']= [
          {header: '학기', name: 'semester', align : 'center', sortable: true},
          {header: '금액', name: 'amt', sortable: true},
          {header: '인원', name: 'qty', sortable: true}
        ];
    },
    perPageChange(event) {
      this.$refs.presidencySchaGrid.invoke("setPerPage", event.target.value);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.presidencySchaGrid.invoke("refreshLayout");
    },
    getCheckedRows () {
      return this.$refs.presidencySchaGrid.invoke('getCheckedRows');
    }
  }
};
</script>

<style lang="css" scoped>
</style>